import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';





class Abtesting extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidMount() {

	}

	async componentDidUpdate() {

	}


	render() {
		const { userTheme } = this.props;
		let poster = require('../../../src/static/AB.png' );
		return (
			<div style={{marginLeft:20}}>
			<p style={{color:userTheme === "dark"? "white" : "black"}}>Craffview provides A/B Testing services that allow you to compare two versions of your product management elements, such as layouts, advertisements, or marketing elements. By conducting simultaneous tests and using statistical analysis, Craffview helps you determine which version performs better and achieves your desired outcomes. This enables you to make data-driven decisions and optimize your product management strategy effectively.</p>
			<img alt="" src={poster} style={{width: '50%'}}></img>
			</div>
			);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	userTheme: state.user.userTheme,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Abtesting);
